import React, { useEffect } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Trophy, TrendingUp, CheckCircle } from 'lucide-react';
import { previousFinalists, participantFeedback } from '../mockData'; // 👈 added participantFeedback
import { useLayoutEffect } from "react";

const PreviousEditions = () => {
  useLayoutEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => {
    const scrollContainer = document.getElementById('finalist-carousel');
    if (!scrollContainer) return;

    let scrollAmount = 0;

    function autoScroll() {
      if (!scrollContainer) return;
      scrollContainer.scrollBy({ left: 0.2, behavior: 'smooth' });
      scrollAmount += 0.2;

      if (
        scrollAmount >=
        scrollContainer.scrollWidth - scrollContainer.clientWidth
      ) {
        scrollAmount = 0;
        scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }

    let autoScrollInterval = setInterval(autoScroll, 160);

    scrollContainer.addEventListener('mouseenter', () =>
      clearInterval(autoScrollInterval)
    );
    scrollContainer.addEventListener('mousedown', () =>
      clearInterval(autoScrollInterval)
    );
    scrollContainer.addEventListener('touchstart', () =>
      clearInterval(autoScrollInterval)
    );

    scrollContainer.addEventListener('mouseleave', () => {
      autoScrollInterval = setInterval(autoScroll, 160);
    });

    return () => clearInterval(autoScrollInterval);
  }, []);

  return (
    <>
      <section className="relative min-h-screen pt-20 pb-16 px-6 bg-[#000000] text-white overflow-hidden">
        {/* Background Glow Effects */}
        <div className="absolute top-1/4 left-0 w-[500px] h-[500px] bg-red-600/10 blur-[180px] rounded-full"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-green-500/10 blur-[180px] rounded-full"></div>

        <div className="max-w-7xl mx-auto relative z-10">
          {/* Header */}
          <div className="text-center mb-20">
            {/* <div className="relative w-28 h-28 mx-auto mb-8">
               <div className="absolute inset-0 bg-gradient-to-br from-red-600 to-green-600 rounded-full animate-glow-pulse shadow-[0_0_40px_rgba(220,38,38,0.6)]"></div>
            <div className="absolute inset-[6px] bg-black rounded-full flex items-center justify-center">
                <Trophy className="w-12 h-12 text-white animate-bounce" />
              </div>
            </div> */}

            {/* <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-green-400 to-red-500 tracking-tight mb-6 animate-gradient">
              Udbhav 1.0 – Previous Edition
            </h1> */}
          <p className="text-2xl font-bold  text-gray-300 max-w-3xl mx-auto text-center mt-6">
            From idea submissions to <span className="text-red-400 font-semibold">real prototypes</span> — 
            the journey of <span className="text-green-400 font-semibold">Udbhav 1.0</span>
          </p>

          </div>
{/* Stats Section – Minimal Glow */}
<div className="grid md:grid-cols-3 gap-8 mb-24">
  {[
    { number: '591', label: 'Ideas Submitted' },
    { number: '27', label: 'Finalist Ideas Shortlisted' },
    { number: '20', label: 'Prototypes Developed' },
  ].map((stat, i) => (
    <div
      key={i}
      className={`
        group relative rounded-3xl p-[2px]
        bg-gray-700/40
        transition-all duration-500
        shadow-md
        animate-[float_6s_ease-in-out_infinite]
      `}
      style={{ animationDelay: `${i * 0.3}s` }}
    >
      {/* Inner card */}
      <div
        className="
          rounded-3xl h-full w-full p-8 text-center
          bg-gray-900/60 backdrop-blur-md
          border border-white/10
          transition-all duration-500
          group-hover:bg-gray-800/70
        "
      >
        {/* Number */}
        <div
          className="
            text-5xl font-bold mb-2
            text-white
            transition-all duration-500
          "
        >
          {stat.number}
        </div>

        {/* Label */}
        <div className="text-gray-300 text-base tracking-wide group-hover:text-white transition-colors duration-300">
          {stat.label}
        </div>
      </div>
    </div>
  ))}
</div>

{/* Floating animation keyframes */}
<style>{`
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
  }
`}</style>


{/* Summary Section */}
<Card className="mb-20 bg-gradient-to-br from-[#111]/80 to-black/90 
                  hover:shadow-[0_0_40px_rgba(34,197,94,0.4)] 
                  transition-all duration-700 relative overflow-hidden p-6">
  <CardHeader className="text-center">
    <CardTitle className="text-2xl md:text-3xl text-red-400 font-bold flex justify-center items-center gap-2 mb-4 animate-pulse">
      <CheckCircle className="w-6 h-6 text-green-400" />
      Udbhav 1.0
    </CardTitle>

    {/* Main Blinking Link */}
    <div className="mt-4 flex justify-center">
<a
  href="https://udbhav.ogesone.com/"
  target="_blank"
  rel="noopener noreferrer"
  className="px-6 py-3 text-base md:text-lg font-semibold rounded-xl
             text-white bg-gradient-to-br from-gray-700/80 to-gray-900/90
             duration-300 hover:from-gray-600/80 hover:to-gray-800/90 transition-all"
>
  Visit Udbhav 1.0 Website
</a>


    </div>
  </CardHeader>
</Card>


          {/* Finalist Carousel */}
          <div className="relative mt-24">
            <h2 className="text-3xl font-bold mb-10 text-green-400 tracking-wide text-center">
              Featured Finalist Projects
            </h2>

            <div
              id="finalist-carousel"
              className="flex overflow-x-auto scrollbar-thin scrollbar-thumb-black scrollbar-track-black/40 space-x-6 snap-x snap-mandatory px-4 pb-4"
            >
              {previousFinalists.map((project) => (
                <Card
                  key={project.id}
                  className="group flex-shrink-0 w-[340px] border border-gray-700 bg-[#0a0a0a] hover:border-red-500 hover:shadow-[0_0_25px_rgba(220,38,38,0.4)] transition-all duration-500 snap-center flex flex-col"
                >
                  <CardHeader className="flex-grow">
                    <div className="flex items-center justify-between mb-3">
                      <Badge variant="outline" className="border-green-400 text-green-300">
                        {project.team}
                      </Badge>
                    </div>
                    <CardTitle className="text-lg text-white mb-2">
                      {project.title}
                    </CardTitle>
                    <CardDescription className="text-sm text-gray-400">
                      {project.description}
                    </CardDescription>
                  </CardHeader>

                  <CardContent className="mt-auto">
                    <Button
                      asChild
                      variant="outline"
                      className="w-full border-green-500 text-green-300 hover:bg-green-500 hover:text-black transition-all duration-300"
                    >
                      <a
                        href="https://udbhav.ogesone.com/winners"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Details
                      </a>
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section> 

      {/* ==============================
          PARTICIPANT VOICES SECTION
      ============================== */}
      <section className="py-24 px-6 text-center bg-black">
        <div className="max-w-7xl mx-auto">
                <h2 className="text-xl md:text-5xl font-bold mb-4 pb-1 leading-tight bg-gradient-to-r from-green-400 via-emerald-500 to-red-500 bg-clip-text text-transparent">
          What Participants Say
        </h2>

          <p className="text-lg text-gray-400 mb-12">
            Real voices from the Udbhav journey
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {participantFeedback.map((feedback, idx) => (
              <div
                key={idx}
                className="bg-gradient-to-br from-[#0B1628] to-[#101F33] border border-[#1e293b]/60 rounded-2xl p-6 text-left shadow-[0_0_15px_rgba(0,0,0,0.2)] hover:shadow-[0_0_25px_rgba(16,185,129,0.3)] transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center space-x-4 mb-5">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-400 to-green-400 flex items-center justify-center font-bold text-white text-lg shadow-md">
                    {feedback.name.charAt(0)}
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-emerald-400">
                      {feedback.name}
                    </h3>
                    <p className="text-gray-400 text-sm">Participant</p>
                  </div>
                </div>
                <p className="text-gray-300 italic leading-relaxed">
                  "{feedback.feedback}"
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default PreviousEditions;
